import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isCartBoxBuilderPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { currentStepSelector, hasUnsavedChangesSelector } from '../../../redux/box-builder/box-builder.selectors';
import { onCloseBoxBuilderPopup } from '../../../redux/box-builder/box-builder.actions';
import CartBoxBuilderPopup from './cart-box-builder-popup';
const mapStateToProps = createStructuredSelector({
  open: isCartBoxBuilderPopupShownSelector,
  currentStep: currentStepSelector,
  hasUnsavedChanges: hasUnsavedChangesSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: onCloseBoxBuilderPopup(dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(CartBoxBuilderPopup);